module.exports = __webpack_public_path__ + "media/images/hawaii_01_small-0e0fce2dab4516ce3b74451fc1432d3a.jpg";